var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngageYourAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "2 0 59 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32.6,
    y1: 1.19,
    x2: 32.6,
    y2: 57.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.78,
    y1: 1.19,
    x2: 31.78,
    y2: 57.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 51.22,
    y1: 1.19,
    x2: 51.22,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 13.87,
    y1: 1.19,
    x2: 13.87,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 9.54,
    y1: 1.19,
    x2: 9.54,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 51.22,
    y1: 1.19,
    x2: 51.22,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 10.73,
    y1: 1.19,
    x2: 10.73,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 50.85,
    y1: 1.19,
    x2: 50.85,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 33.64,
    y1: 1.19,
    x2: 33.64,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 25.94,
    y1: 1.19,
    x2: 25.94,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 32.05,
    y1: 1.19,
    x2: 32.05,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 28.88,
    y1: 1.19,
    x2: 28.88,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 35.25,
    y1: 1.19,
    x2: 35.25,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 27.56,
    y1: 1.19,
    x2: 27.56,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 36.61,
    y1: 1.19,
    x2: 36.61,
    y2: 57.61,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m36.56,45.17c.61.27,1.22.47,1.77.78,3.81,2.13,6.16,5.33,6.97,9.63.14.76.31,1.53.26,2.32-.05.84-.06.87-.96.91-.15,0-.29,0-.44,0-7.67,0-15.35,0-23.02,0-1.53,0-1.57-.01-1.47-1.53.33-5.08,2.72-8.87,7.19-11.32.51-.28,1.05-.51,1.71-.83-2.64-1.84-4.09-4.22-3.91-7.44.12-2.17,1.01-3.95,2.58-5.4,2.83-2.63,7.83-3.09,11.2.54,2.71,2.92,3.53,8.4-1.87,12.36Zm-4.05,12.1c3.42,0,6.85,0,10.27,0,1.11,0,1.17-.07,1.02-1.18-.28-2.08-1.08-3.97-2.41-5.58-2.88-3.5-6.56-5-11.06-4.11-4.71.92-8.19,4.71-9.06,9.8-.17.97-.07,1.08.97,1.08,3.42.01,6.85,0,10.27,0Zm-6.32-19.16c-.02,3.56,2.89,6.57,6.38,6.48,4.02-.11,6.31-3.33,6.35-6.36.04-3.38-2.77-6.48-6.39-6.45-3.52.03-6.33,2.81-6.35,6.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.93,1.19c6.55.03,12.23,4.92,13.41,11.35,1.22,6.66-2.81,14.01-10.45,15.87-2.38.58-4.76.52-7.07-.26-.77-.26-1.27-.16-1.8.44-.84.95-1.74,1.85-2.62,2.77-.4.42-.81.85-1.22,1.27-.33.34-.73.51-1.19.31-.52-.23-.47-.71-.39-1.14.18-.91.41-1.81.64-2.71.25-.99.48-1.99.78-2.97.22-.71.17-1.21-.4-1.82-1.91-2.05-3.09-4.48-3.48-7.28-.71-5.12.99-9.34,4.86-12.67,2.52-2.17,5.6-3.17,8.92-3.15Zm-9.23,28.51c1.12-1.1,2.08-2,3-2.94.55-.56,1.09-.68,1.84-.36,1.74.74,3.56.85,5.44.71,7.08-.53,12.58-7.74,10.62-15.19-1.72-6.55-8.21-10.05-14.01-8.97-7.19,1.34-11.66,8.69-9.52,15.6.59,1.9,1.56,3.58,2.98,4.98.73.72.97,1.48.61,2.51-.39,1.1-.6,2.25-.96,3.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m46.16,44.19c-1.9-1.57-3.07-3.43-2.9-5.87.12-1.72.82-3.23,2.13-4.37,2.69-2.35,6.74-2.14,8.99.42,2.32,2.64,2.57,6.7-1.15,9.76.48.27.94.5,1.38.76,3.4,2.06,5.17,5.09,5.37,9.05.05,1.05-.01,1.1-1.04,1.11-3.42.01-6.85,0-10.27,0-.24,0-.51.02-.72-.06-.47-.19-.6-.67-.59-1.09.01-.47.48-.38.81-.39,2.84,0,5.68,0,8.51,0,.39,0,.78,0,1.17-.01.33-.01.57-.11.5-.52-1.08-6.9-7.96-9.56-13.02-6.65-.55.31-1.02.76-1.52,1.14-.48.36-.69.3-1.19-.24-.35-.37-.13-.6.12-.85.93-.96,2.06-1.62,3.41-2.18Zm3.42-.67c2.7.04,5-2.1,4.94-4.73-.06-3-2.21-4.88-4.77-4.92-2.73-.04-4.8,1.95-4.94,4.76-.14,2.67,2.07,4.85,4.77,4.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m11.91,44.1c-.85-.67-1.47-1.28-1.91-2.06-1.35-2.35-1.31-4.71.18-6.93,1.46-2.18,3.65-3.13,6.23-2.72,2.69.43,4.53,2.04,5.24,4.72.56,2.12.09,4.07-1.34,5.76-.22.26-.49.48-.73.73-.53.54-.55.58.11.9.98.48,1.86,1.08,2.66,1.81.25.23.52.47.2.86-.4.49-.81.61-1.25.3-.48-.34-.9-.76-1.4-1.06-4.69-2.83-10.46-.65-12.46,4.17-.28.68-.52,1.37-.62,2.11-.07.53.07.84.69.82.68-.03,1.37,0,2.05,0,2.4,0,4.79,0,7.19,0,.4,0,.96-.15.96.55,0,.62-.35.98-1.01.98-2.25.02-4.5.01-6.75.01-1.27,0-2.54.01-3.82,0-1.01-.02-1.12-.09-1.05-1.1.3-3.97,2.02-7.09,5.53-9.12.21-.12.44-.22.65-.34.17-.09.33-.19.65-.38Zm8.38-5.42c-.02-2.66-2.23-4.85-4.87-4.82-2.68.02-4.81,2.19-4.79,4.88.01,2.73,2.11,4.79,4.86,4.78,2.73-.02,4.83-2.13,4.81-4.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.77,28.03c-.15-.61-.25-1.23-.45-1.82-.21-.63-.09-1.14.33-1.63.36-.4.68-.84,1.05-1.23.23-.24.3-.87.84-.51.53.36.64,1.03.34,1.52-.03.04-.04.1-.08.12-1.12.83-.9,1.87-.55,2.99.31.98.48,1.99.74,2.99.12.45.21.88-.27,1.17-.52.31-.93.05-1.29-.33-.81-.85-1.63-1.69-2.41-2.57-.53-.6-1.02-.76-1.89-.55C6.98,29.74,1.04,25.83.12,19.61c-.73-4.92,2.03-9.67,6.83-11.38,3.09-1.1,6.06-.79,8.89.85.21.12.43.24.61.4.41.35.46.9.07,1.44-.38.51-.67-.02-.95-.19-3.29-2.1-6.63-2.16-9.94-.11-2.98,1.84-4.91,5.79-3.71,10.01,1.07,3.75,4.77,6.44,8.73,6.38,1.03-.02,2.05-.17,2.99-.61.59-.27,1.03-.17,1.45.26.47.5.92,1.01,1.38,1.51.1-.05.2-.1.3-.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.47,27.83c-.18-.79-.25-1.26-.4-1.71-.37-1.04-.09-1.82.65-2.65,2.81-3.11,3.12-7.77.67-11.1-2.22-3.02-5.25-4.25-8.98-3.61-.97.17-1.27.02-1.46-.71-.07-.28.01-.51.27-.59.51-.16,1.03-.31,1.56-.37,6.3-.72,11.45,3.9,11.82,9.91.16,2.63-.66,5.03-2.36,7.06-.63.75-.87,1.41-.52,2.37.33.91.48,1.89.72,2.84.05.19.13.37.15.57.05.47.25,1.01-.36,1.28-.55.24-.91-.12-1.27-.48-.88-.91-1.8-1.8-2.66-2.73-.38-.41-.71-.49-1.27-.33-2.17.63-4.34.57-6.48-.19-.79-.28-1.53-.64-2.21-1.13-.3-.21-.78-.35-.4-.87.44-.6.75-.71,1.31-.37.88.54,1.82.93,2.83,1.17,1.61.39,3.23.44,4.75-.23,1-.44,1.66-.19,2.3.56.33.39.74.72,1.34,1.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m15.97,17.08c-.02.69-.09,1.26-.78,2.02-1.29,1.4-2.58,2.8-3.88,4.19-.53.56-.57.56-1.14-.05-1.28-1.35-2.55-2.7-3.79-4.08-1.05-1.18-1.16-2.83-.32-4.05.77-1.13,2.45-1.65,3.76-1.19.42.15.74.37.94.55.2-.17.52-.4.97-.56,1.38-.49,2.62.23,2.7.28,1.11.67,1.58,1.9,1.55,2.9Zm-9.24.27c.1.69.5,1.15.82,1.5.78.87,1.84,2,3.19,3.31,1.59-1.38,2.7-2.61,3.42-3.5.32-.4.66-.84.7-1.47.06-.93-.56-2.18-1.77-2.44-.83-.18-1.72.16-2.29.85-.99-.95-2.41-1.05-3.27-.37-.66.52-.9,1.41-.8,2.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m50.64,14.88c.02,2.24-.25,1.89,1.96,1.94.49,0,.98,0,1.46.02.48.02.9.19.86.76-.03.47-.4.64-.83.65-.83.01-1.66,0-2.49.01-.93.02-.94.03-.96,1.01-.01.59,0,1.17,0,1.76,0,.29,0,.59-.04.88-.05.38-.28.65-.68.61-.32-.03-.52-.27-.55-.59-.04-.44-.03-.88-.04-1.32,0-.44,0-.88,0-1.32-.02-1-.03-1-1.09-1.03-.24,0-.49,0-.73,0-.35,0-.73,0-.74-.48-.01-.48.13-.89.7-.93.39-.03.78-.03,1.17-.02.49.01.71-.21.69-.71-.02-.54,0-1.07,0-1.61,0-.34,0-.68,0-1.03.02-.41.11-.8.62-.82.52-.02.66.34.67.77.02.49,0,.98,0,1.47Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m32.91,22.41c-1.03,0-2.06.02-3.08,0-.86-.03-1.19-.29-1.21-1.13-.05-1.76-.03-3.52,0-5.28.01-.76.49-1.38.88-1.99.65-1,1.11-2,1.1-3.26,0-1.43,1.25-2.01,2.47-1.23.84.54,1.22,1.37,1.35,2.33.05.34.03.69,0,1.02-.05.52.19.71.68.7.59-.01,1.18-.03,1.76,0,1.56.09,2.14.99,1.68,2.46-.26.81-.31,1.69-.46,2.52-.14.79-.38,1.59-.4,2.43-.02.91-.57,1.37-1.54,1.41-1.07.05-2.15.01-3.23.01,0,0,0,0,0,0Zm.19-1.26s0,0,0,0c.93,0,1.86,0,2.79,0,.33,0,.63-.17.44-.54-.28-.55-.01-.89.28-1.31.3-.43-.37-.9-.08-1.38.1-.17.22-.32.35-.47.13-.17.2-.35.09-.54-.31-.51-.13-.89.19-1.33.31-.43.14-.68-.42-.68-.78,0-1.56.04-2.35.05-1.74.02-1.78,0-1.35-1.74.2-.82.14-1.55-.29-2.25-.13-.21-.34-.37-.61-.34-.32.04-.35.32-.33.56.15,1.26-.43,2.29-1.11,3.25-.68.97-.94,2.03-.9,3.18.04.98.12,1.95.16,2.93.02.42.21.62.63.62.83,0,1.66,0,2.5,0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m28.04,18.81c0,.83.03,1.66-.01,2.48-.04.77-.33,1.05-1.09,1.1-.63.04-1.27.04-1.9,0-.74-.05-1.1-.37-1.15-1.07-.06-.77-.03-1.56-.02-2.34,0-.49.29-.71.75-.67.46.04.48.4.49.76,0,.39-.01.78,0,1.17.04.82.26.99,1.1.91.34-.03.55-.16.56-.52,0-1.27,0-2.53,0-3.8,0-.33-.14-.57-.51-.56-.41.02-.93-.19-1.1.41-.07.23-.04.48-.07.72-.03.27-.2.44-.48.46-.31.02-.63-.06-.69-.39-.11-.62-.18-1.26.1-1.86.13-.28.36-.46.65-.55.14-.04.29-.06.43-.06,3.12-.08,2.97-.05,2.94,2.64,0,.39,0,.78,0,1.17h0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.66,6.65c0,.44.02.87,0,1.31-.02.31-.16.57-.51.6-.34.03-.58-.18-.62-.49-.12-1.01-.1-2.03,0-3.05.02-.25.23-.44.49-.47.34-.03.58.19.61.5.05.53.01,1.07.01,1.6,0,0,.02,0,.02,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m30.45,8.94c.03.39-.49.71-.83.45-.84-.64-1.6-1.39-2.23-2.25-.14-.2-.1-.46.1-.66.15-.15.35-.23.52-.12.97.64,1.79,1.45,2.42,2.43.02.04.02.09.03.14Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m36.82,6.91c-.03.07-.05.29-.17.41-.63.67-1.27,1.32-1.93,1.95-.27.26-.61.3-.9,0-.25-.27-.15-.57.05-.78.67-.7,1.34-1.39,2.06-2.02.35-.31.84-.08.89.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m27.6,10.57c.49,0,.98-.02,1.46,0,.27.01.46.21.48.47.02.26-.12.51-.37.57-1.06.24-2.13.19-3.19.03-.25-.04-.42-.26-.41-.53,0-.36.24-.53.56-.55.49-.03.98,0,1.47,0v.02Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36.63,10.57c.48,0,.97-.02,1.45,0,.26.01.46.19.49.45.04.32-.14.59-.46.64-1,.14-2.02.16-3.02-.02-.24-.04-.42-.23-.42-.52,0-.35.21-.55.52-.57.48-.03.97,0,1.45,0,0,0,0,0,0,.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngageYourAudience);
export default __webpack_public_path__ + "static/media/Engage Your Audience.8d9d06ebeba50d988c7285bae3125050.svg";
export { ForwardRef as ReactComponent };